export default {
    upgrade: {
        title: 'あなたに合ったプランを選択',
        subtitle: 'プロフェッショナル機能をアンロックし、生産性を向上',
        pickYourPlan: 'プランを選択',
        subscribeSuccess: 'サブスクリプション成功',
        contactSales: 'エンタープライズソリューションについては、営業チームにお問い合わせください。',
        enterpriseRestriction: '有料サブスクリプションは現在、個人ユーザーのみご利用いただけます。企業ユーザーの方は、営業チームまでお問い合わせください。',
        freeplanActivated: 'ベーシックプランが有効です',
        planNotFound: '選択されたプランが見つかりません',
        alreadySubscribed: 'すでにこのプランに登録されています',
        priceIdNotConfigured: 'このプランの支払い設定が利用できません',
        paymentInitFailed: '支払いの初期化に失敗しました。再試行してください。',
        freeTrialCard: {
            title: '無料',
            titleSuffix: '14 日間',
            description: 'クレジットカード不要',
            price: '10,000 トライアル Credits 付き*',
            action: '無料トライアルを開始',
            featuresTitle: '通常の利用目安：',
            features: {
                patentApplicationDraft: '約1件の特許出願',
                inventionDisclosures: 'または約2件の発明開示書',
                officeActionResponses: 'または約2件の拒絶理由対応',
                claimsDrawingsMore: '特許請求の範囲、図面など',
                efficiency: '特許文書作成を最大50%高速化 • 特許図面作成を最大90%高速化',
            },
        },
        maxPlan: {
            planName: 'Max',
            activeStatus: '有効',
            cancelingStatus: '解約予定',
            features: {
                unlimitedDrafting: '特許ドラフト文書を無制限に作成',
                priorityWorkflow: '大量作成向けの優先ワークフロー',
            },
            billing: {
                title: '請求とお支払い',
                cancelPlan: 'プランを解約',
                price: '価格',
                period: '請求期間',
                renewalDate: '更新日',
                cancelDate: '解約日',
                month: '月',
                year: '年',
            },
            cancel: {
                title: 'Max プランを解約',
                description: '解約後も、現在の請求期間が終了するまでは Max プランをご利用いただけます。',
                keepPlan: 'プランを継続',
                confirm: '解約を確定',
                processing: '解約中...',
                otherPlaceholder: '理由をお聞かせください',
                noSubscription: '有効な Max サブスクリプションが見つかりません。',
                success: 'サブスクリプションを解約しました。Max プランは {date} まで有効です。',
                failed: 'サブスクリプションの解約に失敗しました。もう一度お試しください。',
                reasons: {
                    tooExpensive: '高すぎる',
                    missingFeatures: '機能不足',
                    lowQuality: '品質が低い',
                    switchedToAnotherService: '他のサービスに切り替えた',
                    other: 'その他',
                },
            },
        },
        plans: {
            period: {
                monthly: ' / 月',
                yearly: ' / 年',
            },
            basic: {
                name: 'ベーシック',
                subtitle: '初心者に不可欠なコア機能',
                price: '無料',
                description: 'AI を活用した特許ドラフティングを試す発明者や弁理士に最適です。',
                button: '今すぐ始める',
                features: {
                    patentDraftingAgents: '特許ドラフティング Agent へのアクセス。含まれるもの',
                    limitedHiroPrompts: 'Hiro prompts への限定アクセス付き AI 編集',
                },
            },
            pro: {
                name: 'Pro',
                subtitle: 'プロフェッショナル向けの高度なツール',
                description: '特許出願業務フローを高速化',
                button: 'プロプランに申し込む',
                moduleName: 'プロ（月払い/年払い）',
                yearlySavings: '年払いでさらにお得',
                featuresHeader: '世界各国の特許出願に対応した明細書作成支援機能：',
                features: {
                    additionalHiroMessages: 'Hiro コパイロット追加チャット回数',
                    fullDocumentExports: 'フルドキュメントエクスポート',
                    disclosure1Doc: '発明開示書作成 ({n}件)',
                    application1Doc: '特許出願書類作成 ({n}件)',
                    oar1Doc: '拒絶理由通知応答 ({n}件)',
                },
            },
            max: {
                name: 'Max',
                subtitle: '大量作成向けの無制限プラン',
                description: 'ドラフティングと中間処理ワークフローを無制限に利用できます。',
                button: 'Max に申し込む',
                moduleName: 'Max（月払い/年払い）',
                yearlySavings: '年払いでさらにお得',
                features: {
                    unlimitedPatentDraftingAgents: '特許明細書作成エージェントを無制限に利用',
                },
            },
            enterprise: {
                name: 'エンタープライズ',
                subtitle: '組織全体への包括的なインテリジェンス',
                price: 'お問い合わせ',
                description: 'チームまたは組織全体で特許業務を拡張できます。',
                button: 'デモを予約する',
                featuresHeader: 'Max のすべてに加えて：',
                features: {
                    teamUsageHeader: 'チーム利用と管理',
                    teamPooledCredits: 'カスタム配分に対応したチーム共有 credits',
                    adminConsole: '請求、利用状況、ユーザー管理のための管理コンソール',
                    collaborationHeader: 'コラボレーション',
                    sharedWorkspaces: '共有ワークスペースとチームプロジェクト',
                    teamWideIntelligence: 'チーム全体へのインテリジェンス配信',
                    governanceHeader: 'ガバナンスとセキュリティ',
                    ssoSecurity: 'SSO とエンタープライズセキュリティ制御',
                    rolePermissions: 'ユーザーとワークスペース向けロールベース権限',
                    fileUploadControls: 'ファイルアップロード制御',
                    privateIncognito: 'プライベート incognito モード',
                    serviceHeader: 'サービスとサクセス',
                    dedicatedSupport: '専任カスタマーサポート',
                    slaMonitoring: '99.9% SLA とプロアクティブ監視',
                },
                benefits: {
                    expandedSearch: '検索量の拡大',
                    humanInLoop: 'ヒューマン・イン・ザ・ループ',
                    advancedEditor: '高度なインラインエディター',
                    workspaceIntegration: 'ワークスペース統合',
                    professionalExport: 'プロフェッショナルドキュメントエクスポート',
                    evenMoreHiro: 'さらに多くの Hiro コパイロットチャット回数',
                    ssoSecurity: 'SSO シングルサインオン & 高度セキュリティ',
                    dedicatedSuccess: '専属カスタマーサクセスマネージャー',
                },
            },
            api: {
                name: 'Open platform',
                subtitle: '開発者優先の統合ソリューション',
                price: 'カスタム',
                description: '既存のインフラストラクチャに特許インテリジェンスを組み込めます。',
                button: 'API Key を取得',
                featuresHeader: '開発者向け機能：',
                features: {
                    apisHeader: 'カスタムワークフロー向け APIs',
                    dataAiApis: '特許、ライフサイエンス、R&D、市場インテリジェンスにわたる 300+ データ APIs と 60+ AI agent APIs',
                    widgetsHeader: 'Drop-in UI Widgets',
                    dropInWidgets: 'チャート、インサイト、AI ワークフローを製品に組み込み。再構築は不要です',
                    mcpHeader: 'エンタープライズ AI 向け MCP Servers',
                    mcpServers: 'Claude Desktop や Cursor を含む MCP 互換クライアントから、信頼できる PatSnap ツールに接続',
                    skillsHeader: 'Agent Skills & SDKs',
                    agentSkillsSdks: 'LangChain、OpenClaw、CrewAI などのフレームワークでワークフローを構築・オーケストレーション',
                    playgroundHeader: 'Interactive Developer Playground',
                    developerPlayground: 'シナリオデモの確認、API テスト、widgets 構築、コード生成を 1 か所で実行',
                },
            },
            features: {
                hiroMessages: 'Hiro コパイロットとのチャット機能',
                disclosure: '発明開示書作成',
                application: '特許出願書類作成',
                oar: '拒絶理由通知応答',
                patentDrafting: '特許ドラフティング',
                disclosureUnlimited: '発明開示書作成（無制限）',
                patentDraftUnlimited: '特許出願書類作成（無制限）',
                oarDraftUnlimited: '拒絶理由通知応答（無制限）',
                templateInstructionStyle: 'テンプレート / 指示 / スタイルのカスタマイズ',
                customerTemplateInstructionStyle: 'カスタムテンプレート / 指示 / スタイル',
                exportWordDocuments: 'ドラフトした内容を Word ドキュメントとしてエクスポート',
                wordWpsPlugin: 'Eureka Pro（$200）を含む：すべての Eureka エージェントをフル活用',
            },
        },
        billingCycle: {
            monthly: '月払い',
            yearly: '年払い',
            shortSaveAmount: '${amount} 節約',
            saveAmount: '年払いで ${amount} 節約',
        },
        features: 'プラン機能',
        benefits: '特典',
        currentPlan: '現在のプラン',
        recommend: '一番人気',
        audienceTabs: {
            label: '料金対象',
            individual: '個人',
            teams: 'チーム・エンタープライズ',
        },
        comparison: {
            title: 'プランを比較',
            plans: {
                guest: 'ゲスト',
                free: 'ベーシック',
                pro: 'Pro',
                max: 'Max',
                enterprise: 'エンタープライズ',
            },
            categories: {
                agent: 'コア Agent',
                features: 'その他の機能',
                ai: 'AI ツール',
                security: 'セキュリティ・管理',
                collaboration: 'エンタープライズコラボレーション',
            },
            rows: {
                disclosure: '発明開示書作成',
                application: '特許出願書類作成',
                oar: '拒絶理由通知応答',
                templates: 'テンプレート',
                instructions: '指示',
                styles: 'スタイル',
                draftingCenter: 'ドラフティングセンター',
                officePlugin: 'Word プラグイン（近日公開予定）',
                aiChat: 'Hiro',
                chatLimitN: '{n} 回/日',
                chatLimit500: '500 回/日',
                moreUsage: 'より高い上限',
                evenMoreUsage: 'カスタム上限',
                createProject: 'プロジェクト作成',
                exportProject: 'プロジェクトエクスポート',
                sharedAssets: 'テンプレート/指示/スタイル共有',
                enterpriseManagement: 'エンタープライズ管理',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: '支払いセッションを作成中...',
            errors: {
                createSessionFailed: '支払いセッションの作成に失敗しました。現在のアカウントタイプをご確認ください。',
                verifyFailed: '支払い状態の確認に失敗しました',
                verificationFailed: '支払いの確認に失敗しました',
                verificationError: '確認中にエラーが発生しました',
                invalidCallback: '無効な支払いコールバック',
                noPriceId: '価格情報が設定されていません',
            },
        },
    },
};
